module.exports = __webpack_public_path__ + "img/bg4.12c42c63.png";